export const CRITICAL_FAILURE_REASONS = {
  SERVER_BLOCKED: "SERVER_BLOCKED",
  FAILED_TO_BOOT: "FAILED_TO_BOOT",
  BAD_DOMAIN: "BAD_DOMAIN",
  NO_PRODUCTS: "NO_PRODUCTS",
  REQUIRES_SUBSCRIPTION: "REQUIRES_SUBSCRIPTION",
};

export type CriticalFailureReason =
  (typeof CRITICAL_FAILURE_REASONS)[keyof typeof CRITICAL_FAILURE_REASONS];
